import { NavLink } from "hooks/useCustomNavigation";
import "./index.scss";

export const MoreWaysItem = ({
  imageDesktop,
  imageMobile,
  title,
  description,
  linkTo,
  cta
}) => {
  const { line1: titleLine1, line2: titleLine2 } = title;
  const { line1, line2, line3, line4 } = description;
  return (
    <div className="more-ways-item-container" data-testid="more-ways-item">
      <picture>
        <source media="(min-width: 1150px)" srcSet={imageDesktop} />
        <img
          className="more-ways-thumbnail"
          src={imageMobile}
          alt={`${titleLine1} ${titleLine2}`}
        />
      </picture>

      <h3 className="items-title">
        {titleLine1}
        <br />
        {titleLine2}
      </h3>

      <p className="items-description">
        {line1}
        <br />
        {line2}
        <br />
        {line3}
        <br />
        {line4}
      </p>

      <NavLink className="more-ways-anchor" to={linkTo}>
        {cta}
      </NavLink>
    </div>
  );
};
